import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterContratos() {
        return axiosJwt
            .get(`${api}/fornecedor/contratos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTodos(filtro) {
        return axiosJwt
            .get(
                `${api}/fornecedor/contratos/pagamentos?contrato=${filtro.contrato}&dataInicial=${filtro.dataInicial}&dataFinal=${filtro.dataFinal}`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPorId(pagamentoId) {
        return axiosJwt
            .get(`${api}/fornecedor/contratos/pagamentos/${pagamentoId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentosDisponiveis(pagamentoId) {
        return axiosJwt
            .get(
                `${api}/fornecedor/contratos/pagamentos/${pagamentoId}/comprometimentosdisponiveis`
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    associarComprometimentos(pagamentoComprometimentos) {
        return axiosJwt
            .post(
                `${api}/fornecedor/contratos/pagamentos/${pagamentoComprometimentos.pagamentoId}/associarcomprometimentos`,
                pagamentoComprometimentos
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    desassociarComprometimento(pagamentoComprometimento) {
        return axiosJwt
            .post(
                `${api}/fornecedor/contratos/pagamentos/${pagamentoComprometimento.pagamentoId}/desassociarcomprometimento`,
                pagamentoComprometimento
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPagamento(novoPagamento) {
        return axiosJwt
            .post(`${api}/fornecedor/contratos/pagamentos`, novoPagamento)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnexosTipos() {
        return axiosJwt
            .get(`${api}/fornecedor/contratos/pagamentos/anexos/tipos`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    inserirPagamentoAnexo(pagamentoAnexo) {
        const formData = new FormData()
        formData.append('pagamentoId', pagamentoAnexo.pagamentoId)
        formData.append('tipoId', pagamentoAnexo.tipoId)
        formData.append('descritivo', pagamentoAnexo.descritivo)
        formData.append('arquivo', pagamentoAnexo.arquivo)
        formData.append('numeroDocumento', pagamentoAnexo.numeroDocumento)

        return axiosJwt
            .post(
                `${api}/fornecedor/contratos/pagamentos/${pagamentoAnexo.pagamentoId}/anexos`,
                formData,
                {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    excluirAnexo(pagamentoAnexo) {
        return axiosJwt
            .put(
                `${api}/fornecedor/contratos/pagamentos/${pagamentoAnexo.pagamentoId}/anexos`,
                pagamentoAnexo
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    enviarPagamentoParaAnalise(pagamentoDto) {
        return axiosJwt
            .post(
                `${api}/fornecedor/contratos/pagamentos/${pagamentoDto.pagamentoId}/analisar`,
                pagamentoDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterPagamentoAnexo(pagamentoAnexoId) {
        return axiosJwt
            .get(
                `${api}/fornecedor/contratos/pagamentos/anexos/${pagamentoAnexoId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAprovadores(idComprometimento) {
        let url = `${api}/fornecedor/contratos/pagamentos/comprometimentos/${idComprometimento}/aprovadores`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAnexos(idComprometimento) {
        let url = `${api}/fornecedor/contratos/pagamentos/comprometimentos/${idComprometimento}/anexos`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterComprometimentoAnexo(idComprometimento, comprometimentoAnexoId) {
        return axiosJwt
            .get(
                `${api}/fornecedor/contratos/pagamentos/comprometimentos/${idComprometimento}/anexos/${comprometimentoAnexoId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    solicitarAutorizcao(solicitacaoDto) {
        return axiosJwt
            .post(
                `${api}/fornecedor/contratos/pagamentos/${solicitacaoDto.pagamentoId}/solicitarautorizacao`,
                solicitacaoDto
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(pagamentoId) {
        let url = `${api}/fornecedor/contratos/pagamentos/${pagamentoId}/timeline`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLineComprometimento(comprometimentoId) {
        let url = `${api}/fornecedor/contratos/pagamentos/comprometimentos/${comprometimentoId}/timeline`
        return axiosJwt
            .get(url)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    }
}
